<template>
  <div class="content">
    <user-form :datas="dataall"></user-form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.user.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import { UserForm } from "@/pages";
export default {
  components: { UserForm },
  data() {
    return {
      dataall: {
        username: "",
        email: "",
        password: "",
        confirm_password: "",
        first_name: "",
        last_name: "",
        sklad_id: parseInt(localStorage.getItem('sklad_id')),
        staff_id: null,
        role: "Admin",
        rules:[],
        menu_json: {},
        percent:0,
        salary:0,
        salary_type: 'kunlik',
      }
    };
  },
  methods:{
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Фойдаланувчи" });
      },
  },
  mounted:function(){},
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved < 3) {
      this.$store.state.saved = null;
      next();
    } else {
      this.$bvModal.show("modal-close");
    }
  }
};
</script>
